__webpack_require__.p = "/yat/";